<template>
    <div v-if="article.article_languages[0] != null" class="Analysis-list">
        <div class="Analysis-list-left img-scale-in">
            <a :href="$store.state.hrefPrefix + '/articles/' + article.slug"><img v-if="article.blob" :src="article.blob.url" alt=""/></a></div>
        <div class="Analysis-list-right">
            <div class="Analysis-right-top">
                <h2><a :href="$store.state.hrefPrefix + '/category/' + article.category.slug">{{article.category.category_languages[0].pivot.name}}</a></h2>
                <span>{{ formattedCreatedAt }}</span>
            </div>

            <h3><a :href="$store.state.hrefPrefix + '/articles/' + article.slug">{{ article.article_languages[0].pivot.title }}</a></h3>
            <p v-if="article.second_author == null">{{ $t('by') }} <b>{{ article.author.author_languages[0].pivot.name }}</b></p>
            <p v-else>{{ $t('by') }} <b>{{ article.author.author_languages[0].pivot.name }} & {{ article.second_author.author_languages[0].pivot.name }}</b></p>
        </div>
    </div>
</template>

<script>
export default  {
    name: 'SecondSliderMainArticle',
    props: {
        article: {
            type: Object,
            default: []
        },
    },
    computed: {
        formattedCreatedAt() {
            const date = new Date((this.article.published_at ?? this.article.created_at).replace(' ', 'T'));
            const options = { month: 'short', day: 'numeric', year: 'numeric' };
            let locale = 'en-US';
            switch (this.$store.state.language.code) {
                case 'ar':
                    locale = 'ar-LB';
                    break;
                case 'tr':
                    locale = 'tr-TR';
                    break;
            }
            return date.toLocaleDateString(locale, options).toUpperCase();
        }
    }
}
</script>

<style>


</style>
<style scoped>
@media (max-width: 570px) {
    .Analysis-list-left {
        width: 100%;
        max-width: 100%;
    }

    .Analysis-list-right {
        width: 100%;
    }
}
</style>
